import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { engagementApi, useViewed } from "@/lib/engagement";
import { useAuth } from "@/context/AuthContext";

// La domanda di oggi: un voto a testa, percentuali subito dopo; invito discreto alla registrazione per chi non ha account.
export function DailyPoll() {
  const { user } = useAuth();
  const [poll, setPoll] = useState(null);
  const [busy, setBusy] = useState(-1);
  useEffect(() => { engagementApi.poll().then((r) => setPoll(r.poll)).catch(() => {}); }, [user]);
  const ref = useViewed("poll_viewed", !!poll);
  if (!poll) return null;
  const voted = poll.voted !== null && poll.voted !== undefined;
  const vote = async (i) => {
    setBusy(i);
    try { setPoll((await engagementApi.vote(i)).poll); } catch { /* voto non registrato */ } finally { setBusy(-1); }
  };
  return (
    <section ref={ref} data-testid="daily-poll" className="rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-brand mb-2">La domanda di oggi</p>
      <h2 data-testid="daily-poll-question" className="font-serif text-xl sm:text-2xl font-semibold text-onSurface mb-4">{poll.question}</h2>
      {!voted ? (
        <div className="flex flex-wrap gap-2">
          {poll.options.map((o, i) => (
            <button key={o} type="button" data-testid={`daily-poll-option-${i}`} disabled={busy >= 0} onClick={() => vote(i)}
              className="min-w-[88px] px-5 py-2.5 rounded-full border border-hair bg-surface text-sm font-semibold text-onSurface hover:border-brand hover:text-brand transition-colors disabled:opacity-60">
              {busy === i ? <Loader2 size={14} className="animate-spin mx-auto" /> : o}
            </button>
          ))}
        </div>
      ) : (
        <ul data-testid="daily-poll-results" className="space-y-2">
          {poll.options.map((o, i) => (
            <li key={o}>
              <div className="flex justify-between text-sm mb-1">
                <span className={`font-semibold ${poll.voted === i ? "text-brand" : "text-onSurface"}`}>{o}{poll.voted === i ? " · il tuo voto" : ""}</span>
                <span className="font-mono tabular-nums text-onSurface">{poll.percent[i]}%</span>
              </div>
              <div className="h-2 rounded-full bg-hair overflow-hidden"><div className="h-full bg-brand transition-[width] duration-700" style={{ width: `${poll.percent[i]}%` }} /></div>
            </li>
          ))}
          <li className="pt-1 font-mono text-[11px] text-subtle">{poll.total} voti</li>
        </ul>
      )}
      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-xs">
        {poll.article && <Link to={poll.article.path} data-testid="daily-poll-article" className="font-semibold text-brand hover:underline">Leggi la notizia</Link>}
        {voted && !user && <Link to="/registrati" data-testid="daily-poll-register" className="text-subtle hover:text-brand">Registrati gratuitamente a Readoo</Link>}
      </div>
    </section>
  );
}
